module.exports = __webpack_public_path__ + "media/images/flags/es-ga-23a30d01d4c6338e7f5c307f5045cfd6.svg";